import React from "react";
import FrontHeader from "./FrontHeader";
import FrontFooter from "./FrontFooter";
import AdBanner from "./AddBanner";

const FrontLayout = ({ children }) => {
  return (
    <div className="min-h-screen flex flex-col bg-[#F8FAFC] font-sans text-slate-900 overflow-x-hidden">
      <FrontHeader />
      <main className="flex-grow w-full">{children}</main>
      <AdBanner />
      <FrontFooter />
    </div>
  );
};

export default FrontLayout;
